import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Grid, Avatar, Typography, Menu, MenuItem , Button} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import {ChecklistRtlRounded} from '@mui/icons-material';
import SupportAgent from "@mui/icons-material/SupportAgent";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import settingsApi from "Services/Settings";
import ChatApp from "./Bell_icon";
import _ from "lodash";
import { API_ENDPOINTS, CUSTOM_CONSTANTS } from "Constants";

//Redux
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { setNewSiteLogo } from "../../Redux/SiteSettings/actions";

//
import { useDispatch } from "react-redux";

const Header = ({profileDetails}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const triggerHeaderState = useSelector(
    (state) => state?.ProfileSettingsReducer?.triggerHeader
  );
  const siteNewL = useSelector(
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );

  // States
  const [anchorEl, setAnchorEl] = useState(null);
  const [values, setValues] = useState([]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate(0);
  };

  const handledispatcheropen = () => {
    navigate('/dispatcherpanel');
  };

  const handleopentriplist = () =>{
    navigate('/triplist');
  }


  const getMasterValues = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        //console.log("settings fetched ", res?.data?.data);
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getMasterValues();
  }, [ triggerHeaderState, siteNewL, getMasterValues]);

  return (
    <>
      <Grid container className={`${classes.root} ${classes.headernav} ${classes.welcomeContiner}`}>
        {/* Dispatcher panel */}   {/* Trip List */}
        <Grid item xs={6} className={classes.headerleftwrap} >

        <section className={classes.editIcon}>
              {/* Render when accountStatus is APPROVED */}
<Button variant="contained" color="success" className={classes.dispatcherbutton} startIcon={<SupportAgent />}
 onClick={() => handledispatcheropen()}
>
  Dispatcher panel
</Button>
        </section>

      {/* Hide trip list for usertype*/}
        {userType !== "SUB COMPANY" && (     
        <section className={classes.editIcon}>
              {/* Render when accountStatus is APPROVED */}
<Button variant="contained" color="success" className={classes.dispatcherbutton} startIcon={<ChecklistRtlRounded />}
 onClick={() => handleopentriplist()}
>
  Job list
</Button>
        </section>
        )}
    
        </Grid>
       
        <Grid item  xs={6} className={classes.headerrightwrap}>

        {userType !== "SUB COMPANY" && ( <ChatApp /> )}

        <div
            className={classes.avatarContainer}
            id="menu"
            aria-controls={open ? "userMenu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Avatar
              src={
                !_.isEmpty(profileDetails?.image)
                  ? `${profileDetails?.image}`
                  : "/assets/images/user/avatar.png"
              }
              alt={profileDetails?.user_name}
              sx={{ width: 46, height: 46, cursor: "pointer" }}
            />
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>

          <Menu
            id="userMenu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "menu",
            }}
            className={classes.menu}
            
          >
            <MenuItem
              onClick={() => {
                navigate("/profilesettings");
                handleClose();
              }}
              className={classes.menuItem}
            >
              <PersonIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                My Profile
              </Typography>
            </MenuItem>

{userType !== "SUB COMPANY" && ( 
  <MenuItem
              className={classes.menuItem}
              onClick={() => {
                navigate("/settings");
                handleClose();
              }}
            >
              <SettingsIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                Settings
              </Typography>
  </MenuItem>
)}

            <MenuItem
              onClick={() => {
                handleLogout();
                handleClose();
              }}
              className={classes.menuItem}
            >
              <LogoutIcon sx={{ fontSize: 20 }} />
              <Typography variant="body1" className={classes.menuLabels}>
                Logout
              </Typography>
            </MenuItem>
          </Menu>

        </Grid>
    
      </Grid>

    </>
  );
};

export default Header;
